import '@douyinfe/semi-ui-19/react19-adapter';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import zh_CN from '@douyinfe/semi-ui-19/lib/es/locale/source/zh_CN';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './App';
import '@douyinfe/semi-ui-19/lib/es/_base/base.css';
import './styles.css';
import { LocaleProvider, Toast } from './ui/semi';

// Keep operation errors above confirmation popups so rejection details remain visible.
Toast.config({ zIndex: 1050 });

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LocaleProvider locale={zh_CN}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </QueryClientProvider>
    </LocaleProvider>
  </StrictMode>,
);
